export async function fetchBillingStatus() {
  const res = await fetch("/api/fast/billing/status");
  const data = await res.json();
  if (!res.ok || !data.ok) throw new Error(data.error || "Erreur billing.");
  return data;
}

export async function fetchCreditEstimate(payload) {
  const res = await fetch("/api/fast/billing/estimate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const data = await res.json();
  if (!res.ok || !data.ok) throw new Error(data.error || "Erreur estimation credits.");
  return data;
}

export async function startCheckout(planId = "starter") {
  const returnUrl = window.location.href;
  const res = await fetch("/api/fast/billing/checkout", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      plan_id: planId,
      success_url: returnUrl,
      cancel_url: returnUrl
    })
  });
  const data = await res.json();
  if (!res.ok || !data.ok || !data.checkout_url) {
    throw new Error(data.error || "Checkout indisponible.");
  }
  window.location.href = data.checkout_url;
}

export async function startPortal() {
  const returnUrl = window.location.href;
  const res = await fetch("/api/fast/billing/portal", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ return_url: returnUrl })
  });
  const data = await res.json();
  if (!res.ok || !data.ok || !data.portal_url) {
    throw new Error(data.error || "Portail indisponible.");
  }
  window.location.href = data.portal_url;
}

export async function fetchPlans() {
  const res = await fetch("/api/fast/billing/plans");
  const data = await res.json();
  if (!res.ok || !data.ok) throw new Error(data.error || "Erreur plans.");
  return data.plans || [];
}

export async function fetchTopups() {
  const res = await fetch("/api/fast/billing/topups");
  const data = await res.json();
  if (!res.ok || !data.ok) throw new Error(data.error || "Erreur topups.");
  return data.packs || [];
}

export async function startTopupCheckout(packId) {
  const returnUrl = window.location.href;
  const res = await fetch("/api/fast/billing/topup", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ pack_id: packId, success_url: returnUrl, cancel_url: returnUrl })
  });
  const data = await res.json();
  if (!res.ok || !data.ok || !data.checkout_url) {
    throw new Error(data.error || "Checkout indisponible.");
  }
  window.location.href = data.checkout_url;
}
